export const documentTransmittalDataGrid = [
  {
    label: "Number",
    field: "number",
    grid: 1.2,
  },
  {
    label: "Rev",
    field: "rev",
    grid: 0.8,
  },
  {
    label: "Current Lifecycle",
    field: "lifecycle",
    grid: 1.2,
  },
  {
    label: "Date",
    field: "date",
    grid: 0.8,
  },
];

export const projectDataGrid = [
  {
    label: "Project Name",
    field: "name",
    grid: 1.2,
  },

  {
    label: "Project Rev",
    field: "rev",
    grid: 1.2,
  },
  {
    label: "Project Type",
    field: "type",
    grid: 1.2,
  },
];

export const clientDataGrid = [
  {
    label: "Client Name",
    field: "name",
    grid: 1.2,
  },
  {
    label: "Client Email",
    field: "email",
    grid: 1.2,
  },
];

export const vendorDataGrid = [
  {
    label: "Vendor Name",
    field: "name",
    grid: 1.2,
  },
  {
    label: "Vendor Email",
    field: "email",
    grid: 1.2,
  },
];
